import { Suspense, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { useInView } from "framer-motion";

// Canvas that only runs its render loop while on-screen (pauses offscreen WebGL).
export function VisibleCanvas({ children, className = "", camera, dpr = [1, 1.8], gl, style }) {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "150px 0px" });
  return (
    <div ref={ref} className={className} style={style}>
      <Canvas
        frameloop={inView ? "always" : "never"}
        dpr={dpr}
        camera={camera}
        gl={{ antialias: true, alpha: true, powerPreference: "high-performance", ...(gl || {}) }}
      >
        <Suspense fallback={null}>{children}</Suspense>
      </Canvas>
    </div>
  );
}
